import jwtDecode from 'jwt-decode';

const storageItemKey = (key) => `lnf.srs.${key}`;

export const storageItems = {
    local: {
        accessToken: storageItemKey('accessToken'),
        supplierName: storageItemKey('supplierName'),
    },
};

export default {
    local: {
        getAccessToken() {
            return localStorage.getItem(storageItems.local.accessToken);
        },

        getEmail() {
            const accessToken = this.getAccessToken()
            const decoded = jwtDecode(accessToken)
            return decoded.email
        },

        getPasswordChanged() {
            const accessToken = this.getAccessToken()
            const decoded = jwtDecode(accessToken)
            return decoded.passwordChanged == 'true' || decoded.passwordChanged == true
        },

        getSupplierInternalId() {
            const accessToken = this.getAccessToken()
            const decoded = jwtDecode(accessToken)
            return Number(decoded.supplierInternalId)
        },

        getSupplierName() {
            const accessToken = this.getAccessToken()
            const decoded = jwtDecode(accessToken)
            return decoded.supplierName
        },

        getTokenInfo() {
            const accessToken = this.getAccessToken()
            return jwtDecode(accessToken)
        },

        getUserId() {
            const accessToken = this.getAccessToken();
            const decoded = jwtDecode(accessToken);
            return Number(decoded.userId);
        },

        /**
         * @returns {String}
         */
        getUserRoleName() {
            const accessToken = this.getAccessToken();
            const decoded = jwtDecode(accessToken);
            return decoded.roleName;
        },

        removeAccessToken() {
            localStorage.removeItem(storageItems.local.accessToken);
        },

        setAccessToken(accessToken) {
            localStorage.setItem(storageItems.local.accessToken, accessToken);
        }
    },
};
